module.exports = __webpack_public_path__ + "static/media/90s.8440c42d.png";